import { render } from "./ModalEditGlobal.vue?vue&type=template&id=2362907d"
import script from "./ModalEditGlobal.vue?vue&type=script&lang=js"
export * from "./ModalEditGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__